import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import {useState} from 'react'
import { useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL
const theme = createTheme();

const Login = () => {

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  async function handleSubmit(event){
   event.preventDefault()

   const response = await fetch(`${apiUrl}/admin/login`, {
    method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({
        username,
        password
      }),
   })
                            
   const data = await response.json()
   console.log("what in the reposnds to save in token from login", data.access_token)
   if (data.access_token) {
    localStorage.setItem('token', data.access_token)
    window.location.href = '/'
   } else {
    alert('please check your username and password')
   }

  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login to Leon Admin
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              value={username}
              onChange= {(e) => setUsername(e.target.value)}
              margin="normal"
              required
              fullWidth
              id="usename"
              label="username Address"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              value={password}
              onChange= {(e) => setPassword(e.target.value)}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Login;
